export default __webpack_public_path__ + "static/via-metamask@2x-b88cef0cb446384c0912b5cfb8c27626.png";